export enum WidgetType {
  Notification ,
  Company ,
  Workflow,
}
